import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
    providedIn: 'root'
})
export class ModalService {

    /**
     * Define se o modal deve estar visivel.
     */
    public isVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

    constructor() { }
}
